import './responsivePlayer.styles.scss';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { ModalOverlay } from './ModalOverlay';
import { PlayButton } from './PlayButton';

const videoCoverImage = require(`./../../assets/images/venue-landing/vendor-signup-video-cover.png`);


type ResponsivePlayerProps = {
    videoUrl: string;
};

export const ResponsivePlayer = ({ videoUrl }: ResponsivePlayerProps) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <div className='responsive-player'>
            <div className='responsive-player__video'>
                <PlayButton imgUrl={videoCoverImage} onClick={() => setShowModal(true)} />
            </div>
            <div className='responsive-player__video-button'>
                <PlayButton onClick={() => setShowModal(true)} />
            </div>
            <ModalOverlay onClose={() => setShowModal(false)} show={showModal}>
                <ReactPlayer width='80vw' height='auto' playing={showModal} url={videoUrl} />
            </ModalOverlay>
        </div>
    );
};
